export default __webpack_public_path__ + "static/media/sol-phantoms-animated.badbce56.gif";